
import wx from 'weixin-js-sdk'
import { getConfig, addFile } from '@/api/wx.js'
import addressPicker from './address.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import { declare, getAreaType, getDetail, modify } from '@/api/mamixiaowu'
import { lazyAMapApiLoaderInstance, AMapManager } from 'vue-amap'
import markerIcon from '../../assets/mamixiaowu/dingwei@3x.png'
import config from '@/config/index'
let amapManager = new AMapManager()
export default {
directives: {
TransferDom
},
name: 'declare',
components: {
Cell,
Group,
XInput,
XTextarea,
XButton,
Selector,
Popup,
addressPicker
},
data () {
return {
baseUrl: config.baseUrl,
zoom: 12,
amapManager,
num: '5',
mapCenter: [120.15417, 30.183178],
map: null,
overlays: [],
markers: [], // 默认点
showMap: false,
areatypeList: [],
addressValue: [],
shenbaoObj: {
unitname: '',
areatype: this.$store.state.user.workerObj.areatype,
provinceid: '',
cityid: '',
countyid: '',
unithomenum: '',
homename: '',
homeaddress: '',
longitude: '',
latitude: '',
telphone: '',
homearea: '',
homefacilities: '',
homeimgs: '',
homevideo: '',
homeintroduce: '',
externallinks: '',
accountid: this.$store.state.user.accountid,
sourcetype: 1
},
photoObj: {
imgcount: 5,
imglist: [],
fileUrlArr: []
},
sourcetype: 1,
id: this.$route.params.id,
events: {
init: (o) => {
this.$refs.map.$amap.setFitView()
}
},
searchOption: {
city: '杭州市',
citylimit: true
}
}
},
computed: {
accountid () {
return this.$store.state.user.accountid
}
},
mounted () {
console.log(this.$store.state.user.workerObj.areatype)
this.wxconfig()
this.getLocation()
if (this.id) {

this.getDetail(this.getAreaType)
} else { // 新增申报
this.getAreaType()
}
let _this = this
setTimeout(() => {
lazyAMapApiLoaderInstance.load().then(() => {
_this.map = amapManager.getMap()
_this.map.clearMap()
let mouseTool = new AMap.MouseTool(_this.map)
console.log(mouseTool)

mouseTool.on('draw', function (e) {
_this.markers = []



if (_this.overlays.length > 0) {
_this.map.remove(_this.overlays)
_this.overlays = []
}
_this.overlays.push(e.obj)
_this.shenbaoObj.longitude = e.obj.getPosition().lng
_this.shenbaoObj.latitude = e.obj.getPosition().lat
})
mouseTool.marker({

content: `<div style="z-index:9999"><img src="${markerIcon}" width="35"></div>`
})
})
}, 1000)
},
methods: {

getDetail (fn) {
getDetail({
accountid: this.accountid,
sourcetype: this.sourcetype,
id: this.id
}).then(res => {
let obj = res.returnValue
this.shenbaoObj = {
id: this.id,
unitname: obj.unitname,
areatype: obj.areatype,
provinceid: obj.provinceid,
cityid: obj.cityid,
countyid: obj.countyid,
unithomenum: obj.unithomenum,
homename: obj.homename,
homeaddress: obj.homeaddress,
longitude: obj.longitude,
latitude: obj.latitude,
telphone: obj.telphone,
homearea: obj.homearea,
homefacilities: obj.homefacilities,
homeimgs: obj.homeimgs,
homevideo: obj.homevideo,
homeintroduce: obj.homeintroduce,
externallinks: obj.externallinks,
accountid: this.$store.state.user.accountid,
sourcetype: 1
}
this.photoObj.imglist = obj.homeimgsFile
this.photoObj.fileUrlArr = []
obj.homeimgsFile.forEach(el => {
this.photoObj.fileUrlArr.push(el.filepath)
})
this.addressValue = [
obj.provinceid.toString(),
obj.cityid.toString(),
obj.countyid.toString()
]
let arr = [this.shenbaoObj.longitude, this.shenbaoObj.latitude]
this.center = arr 
this.markers = [

{
position: arr,
content: `<div style="z-index:9999"><img src="${markerIcon}" width="35"></div>`
}
]
if (fn) fn()
})
},

getAreaType () {
let areatype = this.shenbaoObj.areatype
getAreaType().then(res => {
this.areatypeList = res.obj.filter(item => {
if (areatype === '4') {

return item.key === '4'
} else if (areatype === '5') {

return item.key === '5'
} else if (parseInt(item.key) >= parseInt(areatype)) {
return parseInt(item.key) >= parseInt(areatype)
}
})
console.log(this.areatypeList)
})
},
submit () {
this.shenbaoObj.provinceid = this.addressValue[0] || ''
this.shenbaoObj.cityid = this.addressValue[1] || ''
this.shenbaoObj.countyid = this.addressValue[2] || ''

let arr = this.photoObj.imglist.map(item => item.id)
this.shenbaoObj.homeimgs = arr.join(';')
if (this.shenbaoObj.unitname === '') {
this.$vux.toast.text('请先填写单位名称')
return false
}
if (this.shenbaoObj.areatype === '') {
this.$vux.toast.text('请先选择地区级别')
return false
}
if (this.shenbaoObj.areatype === '1' && this.shenbaoObj.provinceid === '') {
this.$vux.toast.text('请先选择所在地区')
return false
} else if ((this.shenbaoObj.areatype === '3' || this.level === '4') && this.shenbaoObj.cityid === '') {
this.$vux.toast.text('请先选择所在地区')
return false
} else if (this.shenbaoObj.areatype === '5' && this.shenbaoObj.countyid === '') {
this.$vux.toast.text('请先选择所在地区')
return false
}
if (this.shenbaoObj.unithomenum === '') {
this.$vux.toast.text('请先填写单位职工数')
return false
}
if (this.shenbaoObj.telphone === '') {
this.$vux.toast.text('请先填写联系电话')
return false
}
if (this.shenbaoObj.homename === '') {
this.$vux.toast.text('请先填写小屋名称')
return false
}
if (this.shenbaoObj.homeaddress === '') {
this.$vux.toast.text('请先填写小屋地址')
return false
}
if (this.shenbaoObj.longitude === '' || this.shenbaoObj.latitude === '') {
this.$vux.toast.text('请在地图上标注小屋地址')
return false
}
if (this.shenbaoObj.homearea === '') {
this.$vux.toast.text('请先填写小屋面积')
return false
}
if (this.shenbaoObj.homefacilities === '') {
this.$vux.toast.text('请先填写小屋设施')
return false
}
if (this.shenbaoObj.homeintroduce === '') {
this.$vux.toast.text('请先填写小屋介绍')
return false
}
if (this.shenbaoObj.homeimgs === '') {
this.$vux.toast.text('请先上传图片')
return false
}
let _this = this
if (this.id) {

modify(this.shenbaoObj).then(res => {
this.$vux.alert.show({
content: '修改成功',
onHide () {
_this.$router.go(-1)
}
})
})
} else {
declare(this.shenbaoObj).then(res => {
this.$vux.alert.show({
content: '提交成功',
onHide () {
_this.$router.replace({
name: 'mamixiaowuWorkspaceDealList'
})
}
})
})
}
},
mapSubmit () {
if (this.shenbaoObj.longitude === '' || this.shenbaoObj.latitude === '') {
this.$vux.toast.text('请在地图上标注小屋地址')
return false
}
this.showMap = false
},

onClick () {
this.showMap = true
},

wxconfig () {
let ua = window.navigator.userAgent.toLowerCase()

let href = window.location.href.split('#')[0]
if (
ua.match(/MicroMessenger/i) == 'micromessenger' &&
ua.match(/wxwork/i) == 'wxwork'
) {
href = window.location.href.split('#')[0]

} else if (ua.match(/micromessenger/i) == 'micromessenger') {
href = this.$store.state.user.wechatSignUrl

}
getConfig({
url: href
}).then(re => {
var configs = re.returnValue
wx.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: configs.appId, // 必填，公众号的唯一标识
timestamp: configs.timestamp, // 必填，生成签名的时间戳
nonceStr: configs.nonceStr, // 必填，生成签名的随机串
signature: configs.signature, // 必填，签名，见附录1
jsApiList: ['chooseImage', 'uploadImage', 'previewImage', 'getLocation'] 
})
})
},

chooseFile (imglist, imgcount) {
console.log('list', imglist)
console.log('count', imgcount)
let count = imgcount - imglist.length

var _this = this
wx.chooseImage({
count: count, // 默认9
sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
success: res => {
var localIds = res.localIds
_this.index = 0
if (localIds.length > 0) {
_this.uploadFile(imglist, localIds)
}
}
})
},

uploadFile (imglist, localIds) {
var _this = this
if (_this.index >= localIds.length) {
return
}
wx.uploadImage({
localId: localIds[_this.index], // 需要上传的图片的本地ID，由chooseFile接口获得
success: res => {
addFile({
mediaId: res.serverId
}).then(re => {
imglist.push(re.returnValue)
_this.photoObj.fileUrlArr.push(re.returnValue.filepath)
_this.index++
_this.uploadFile(imglist, localIds)
})
}
})
},

preview (index, fileList) {
let arr = fileList.map(item => this.baseUrl + item)
wx.previewImage({
current: arr[index], // 当前显示图片的http链接
urls: arr 
})
},
del (index) {
this.photoObj.imglist.splice(index, 1)
},
getLocation () {
wx.ready(() => {
wx.getLocation({
type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
success: (res) => {
this.mapCenter = [res.longitude, res.latitude]
let geocoder = new AMap.Geocoder({
city: ''
})
geocoder.getAddress(this.mapCenter, (status, result) => {
if (status === 'complete' && result.info === 'OK') {
var city = result.regeocode.addressComponent.city
this.searchOption.city = city
}
})
}
})
})
},
onSearchResult (pois) {
let latSum = 0
let lngSum = 0
this.markers = []
if (pois.length > 0) {
pois.forEach(poi => {
let { lng, lat } = poi
lngSum += lng
latSum += lat
this.markers.push({
position: [poi.lng, poi.lat],
content: `<div style="z-index:9999"><img src="${markerIcon}" width="35"></div>`
})
})
let center = {
lng: lngSum / pois.length,
lat: latSum / pois.length
}
this.mapCenter = [center.lng, center.lat]
}
}
}
}
